import { FieldSchema } from "../../../Schema";
import { readStoredText } from "../../common/fields/stored";

export const configurationBaseline: FieldSchema = {
  grid: {
    displayed: true,
    order: 28,
    sortable: false,
  },
  name: "configurationBaseline",
  // Declared for both inbound directions: the rule belongs to the attribute, not to
  // whether the record arrived from AppSync or from a DynamoDB read.
  dataTransform: {
    fromGraphql: { getter: ({ configurationBaseline }) => readStoredText(configurationBaseline) },
    fromDb: { getter: ({ configurationBaseline }) => readStoredText(configurationBaseline) },
  },
  display: {
    displayed: true,
  },
  form: { label: "Configuration baseline" },
};
